import React, { useEffect, useState } from "react";
import { connect } from "react-redux";

import { login } from "../../store/actions";
import {
    AUTH_CONFIG,
    REACT_APP_SAML_CLIENT_ID,
    REACT_APP_SAML_REDIRECT_URI,
    REACT_APP_SAML_BASE_URL,
    REACT_APP_COLBI_THEME,
} from "../../environmentVariables";

import { Redirect } from "react-router";

import Oidc from "oidc-client";
import { parse } from "query-string";

import { UserRoles } from "../../enums/userRoles";
import { decodeUserSession } from "../../utils/utils";
import LoadingPage from "./LoadingPage";

const oidcSettings = {
    ...AUTH_CONFIG,
    authority: REACT_APP_SAML_BASE_URL,
    client_id: REACT_APP_SAML_CLIENT_ID,
    redirect_uri: REACT_APP_SAML_REDIRECT_URI,
    response_type: "code",
};

const userManager = new Oidc.UserManager(oidcSettings);

async function initAuth() {
    const user = await userManager.getUser();
    if (!user) {
        return await userManager.signinRedirect();
    }
}

const SAMLCallback = (props) => {
    const { match, login, user, location } = props;

    const [loginAttempt, setAttempt] = useState(false);
    const [loading, setLoading] = useState(true);

    const locale = match.params.locale || "en";
    const userInformation = decodeUserSession(user);
    const [appTheme] = useState(
        REACT_APP_COLBI_THEME
            ? REACT_APP_COLBI_THEME.toLocaleLowerCase()
            : document.localStorage.getItem("theme")
              ? document.localStorage.getItem("theme")
              : "sovos",
    );

    useEffect(() => {
        const root = document.getElementsByTagName("html")[0];
        root.setAttribute("class", appTheme);
    }, [appTheme]);

    useEffect(() => {
        async function checkAuthAndLoadProfile() {
            const user = await userManager.getUser();

            if (user) {
                login(user.profile.email.toLowerCase(), "", user.profile["sovos:samlEntityId"], {
                    setAttempt: setAttempt,
                });

                setLoading(false);
            } else {
                try {
                    let { profile } = await userManager.signinRedirectCallback();
                    window.history.replaceState({}, document.title, window.location.pathname);
                    login(profile.email.toLowerCase(), "", profile["sovos:samlEntityId"], {
                        setAttempt: setAttempt,
                    });

                    setLoading(!!profile);
                } catch (error) {
                    initAuth();
                }
            }
        }

        checkAuthAndLoadProfile();
        return () => {};
    }, [login, loginAttempt]);

    if (loginAttempt && !loading && userInformation) {
        const { redirect } = parse(location.search);
        return (
            <Redirect
                to={
                    redirect || userInformation.role === UserRoles.BACKOFFICE
                        ? `/${locale}/settings/`
                        : `/${locale}/`
                }
            />
        );
    }

    if (loginAttempt && !loading && !userInformation) {
        return <Redirect to={`/${locale}/forbidden`} />;
    }

    return <LoadingPage />;
};

export default connect(({ user }) => ({ user }), { login })(SAMLCallback);
